import { masterClinicalRoomActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  masterClinicalRoomList: null,
  postMasterClinicalRoomData: null,
  getMasterClinicalRoomById: null,
  deleteMasterClinicalRoom: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {

    case masterClinicalRoomActionTypes.get_master_clinicalroom.REQUEST:
      return {
        ...state,
        loading: true,
        masterClinicalRoomList: null,
      };
    case masterClinicalRoomActionTypes.get_master_clinicalroom.SUCCESS:
      return {
        ...state,
        masterClinicalRoomList: payload,
        loading: false,
      };
    case masterClinicalRoomActionTypes.post_master_clinicalroom.REQUEST:
      return {
        ...state,
        loading: true,
        postMasterClinicalRoomData: null,
      };
    case masterClinicalRoomActionTypes.post_master_clinicalroom.SUCCESS:
      return {
        ...state,
        postMasterClinicalRoomData: payload,
        loading: false,
      };
    case masterClinicalRoomActionTypes.get_master_clinicalroom_by_id.REQUEST:
      return {
        ...state,
        loading: true,
        getMasterClinicalRoomById: null,
      };
    case masterClinicalRoomActionTypes.get_master_clinicalroom_by_id.SUCCESS:
      return {
        ...state,
        loading: false,
        getMasterClinicalRoomById: payload,
      };
    case masterClinicalRoomActionTypes.delete_master_clinicalroom.REQUEST:
      return {
        ...state,
        loading: true,
        deleteMasterClinicalRoom: null,
      };
    case masterClinicalRoomActionTypes.delete_master_clinicalroom.SUCCESS:
      return {
        ...state,
        deleteMasterClinicalRoom: payload,
        loading: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterClinicalRoom/reducers/MasterClinicalRoomReducer.js